// extracted by mini-css-extract-plugin
export default {"button":"close-buttons__button___VZAjS","buttonIE":"close-buttons__buttonIE___S5Hyv","buttonIe":"close-buttons__buttonIE___S5Hyv"};